import React from 'react';

import { useTranslations } from '@vk-hr-tek/core/hooks';

import { AppAbilities } from '@app/ability';
import { CustomDropdownItem } from '@app/gen/side_menu';

import {
  customLinkToNavigationItem,
  sidebarCustomIcons,
  systemLinkToNavigationItem,
} from '../helpers';
import { SidebarItemsWithSubmenu } from '../SidebarItemsWithSubmenu';

interface SidebarCustomDropdownItemProps {
  item: CustomDropdownItem;
  sidebarOpened: boolean;
  isActive: (path: string, href: string) => boolean;
  skeletonLoading: boolean;
  pathname: string;
  onMenuItemClick: (pageTitle: string) => void;
  setSubmenusVisibleItemsCount?: (count: number) => void;
}

export const SidebarCustomDropdownItem = ({
  sidebarOpened,
  item,
  pathname,
  isActive,
  skeletonLoading,
  onMenuItemClick,
  setSubmenusVisibleItemsCount,
}: SidebarCustomDropdownItemProps) => {
  const { t } = useTranslations();

  const { icon, children, name } = item;

  const isActiveItem = isActive(pathname, name);
  const basename = item.name.toLowerCase().split(' ').join('-');

  const icons = sidebarCustomIcons();
  const sidebarIcon = icon ? icons[icon] : icons.globe;

  const submenuItems = children.map((childItem) => {
    const link =
      childItem.type === 'custom_link_item'
        ? customLinkToNavigationItem(childItem)
        : systemLinkToNavigationItem(childItem);
    return {
      aqaClass: `aqa_${link.basename}`,
      title: link.title
        ? link.title
        : t(
            `modules.${link.parentResource ?? link.resource}.${link.basename}.${
              link.role
            }Title`,
          ),
      href: link.href ?? '',
      isCustom: !!link.title,
      resource: link.resource as AppAbilities[1],
      externalSystem:
        'external_system' in childItem ? childItem.external_system : false,
      blank: 'blank' in childItem ? childItem.blank : false,
    };
  });

  return (
    <SidebarItemsWithSubmenu
      icon={sidebarIcon}
      title={name}
      sidebarOpened={sidebarOpened}
      isActive={isActiveItem}
      skeletonLoading={skeletonLoading}
      aqaClass={`aqa_${basename}`}
      onMenuItemClick={onMenuItemClick}
      submenu={submenuItems}
      setSubmenusVisibleItemsCount={setSubmenusVisibleItemsCount}
    />
  );
};
